import axios from 'axios';

import { getUserTokenFromLocalStorage, removeUserTokenFromLocalStorage } from '@utils/localStorage';

export const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/admin`,
});

// Optionally add interceptors (401 handling, token refresh, etc.)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 Unauthorized globally
    if (error.response?.status === 401) {
      removeUserTokenFromLocalStorage();
      window.location.replace('/');
    }

    return Promise.reject(error);
  },
);

// Needed because on initial load, the token might not be present on axios instance call
apiClient.interceptors.request.use((config) => {
  const token = getUserTokenFromLocalStorage();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
